export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  home: "nav-home",
  services: "nav-services",
  serviceAreas: "nav-service-areas",
  about: "nav-about",
  reviews: "nav-reviews",
  contact: "nav-contact",
  phoneCta: "nav-phone-cta",
  mobileToggle: "nav-mobile-toggle",
};

export const HERO = {
  phoneCta: "hero-phone-cta",
  scheduleBtn: "hero-schedule-btn",
  estimateBtn: "hero-estimate-btn",
};

export const FORM = {
  root: "contact-form",
  name: "form-name",
  phone: "form-phone",
  email: "form-email",
  address: "form-address",
  city: "form-city",
  service: "form-service",
  urgency: "form-urgency",
  preferred: "form-preferred",
  message: "form-message",
  submit: "form-submit",
  success: "form-success",
  phoneCta: "form-phone-cta",
};

export const FOOTER = {
  phone: "footer-phone",
  contact: "footer-contact-btn",
  credit: "footer-credit",
};
